/** Get Dom Elements
 * @param {object} selectors: keyed list of dom selectors
 * @param {element} baseElem(optional): parent element that contains all selectors
 * with pattern { key: 'selector' }
 * example:  masthead: '[data-js-masthead]'
 * @returns {object}: either returns null or an object
 * with pattern { key: domElement }
 */
export const getDomElems = (selectors, baseElem) => {
  const baseElement = baseElem || document;
  const domElems = Object.keys(selectors).reduce((previous, cur) => {
    const prev = previous;
    prev[cur] = baseElement.querySelector(selectors[cur]);
    return prev;
  }, {});
  /* confirm they are all dom elems */
  const values = Object.keys(domElems).map((e) => domElems[e]);
  const areElems = values.every((el) => el instanceof Element);
  /* if they're all dom elems, return the new obj, otherwise null */
  return areElems ? domElems : null;
};

/**
 * Returns an array of all focusable elements found with the given param
 * @param {object} elem: DOM element to query for focusable descendent elems
 * @returns {*[]}: array of domElements
 */
export const getFocusableElems = (elem) => (
  [...elem.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])')]
);

export const isVisible = (elem) => (
  elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length
);

/**
 * Returns an array of all visible, focusable elements found with the given param
 * @param {object} elem: DOM element to query for focusable descendent elems
 * @returns {*[]}: array of domElements
 */
export const getVisibleFocusableElems = (elem) => (
  getFocusableElems(elem).filter((el) => isVisible(el))
);
